import axios from './axios.js';

// 获取code列表
export const getCodeLsit = (data) => {
    return axios({
        method: 'get',
        url: 'api/IPRCloud2/S/Code/GetSysCodeItems',
        params: data
    });
}

// 获取资讯列表
export const getNewsList = (data) => {
    return axios({
        method: 'post',
        url: 'api/News/GetNewsList',
        data
    });
}

// 获取资讯详情
export const getNewInfo = (data) => {
    return axios({
        method: 'post',
        url: 'api/News/GetNewsInfo',
        data
    });
}

// 获取专家列表
export const getExpertList = (data) => {
    return axios({
        method: 'post',
        url: 'api/IPRCloud2/S/Expert/GetExpertList',
        data
    });
}

// 获取专家详情
export const getExpert = (data) => {
    return axios({
        method: 'get',
        url: 'api/IPRCloud2/S/Expert/GetExpert',
        params: data
    });
}

// 获取案例分类
export const getCaseTypes = () => {
    return axios({
        method: 'get',
        url: 'api/IPRCloud2/S/ProjectCase/GetClassifications'
    });
}

// 获取案例列表
export const getCaseList = (data) => {
    return axios({
        method: 'post',
        url: 'api/IPRCloud2/S/ProjectCase/GetCaseList',
        data
    });
}

// 获取招聘职位列表
export const getJobOffersList = (data) => {
    return axios({
        method: 'post',
        url: 'api/IPRCloud2/S/JobOffers/GetJobOffersList',
        data
    });
}